var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "row" }, [
    _c(
      "div",
      { staticClass: "col-md-6" },
      [
        _c("csp-form-group-select-insurance-policy-parent", {
          attrs: {
            "insurance-policy-form": _vm.insurancePolicyForm,
            property: "parentInsuranceId",
            required: !_vm.isDeliveryClaim,
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "w-100" }),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "col-md-6" },
      [
        _c("csp-form-group-input", {
          attrs: {
            form: _vm.insurancePolicyForm,
            "label-property": "policyholderInsuranceReference",
            property: "adversaryInsuranceReference",
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "col-md-6" },
      [
        _c("csp-form-group-input", {
          attrs: {
            form: _vm.insurancePolicyForm,
            property: "insurancePolicyNr",
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "w-100" }),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "col-md-6" },
      [
        _c("csp-form-group-optional-bool", {
          attrs: {
            form: _vm.insurancePolicyForm,
            "label-cols": 6,
            property: "partialCoverage",
            type: "text",
          },
        }),
        _vm._v(" "),
        _vm.isPartialCoverageYesSelected
          ? _c("csp-form-group-input", {
              attrs: {
                form: _vm.insurancePolicyForm,
                property: "partialCoverageCopayment",
              },
            })
          : _vm._e(),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "col-md-6" },
      [
        _c("csp-form-group-optional-bool", {
          attrs: {
            form: _vm.insurancePolicyForm,
            "label-cols": 6,
            property: "comprehensive",
            type: "text",
          },
        }),
        _vm._v(" "),
        _vm.isComprehensiveYesSelected
          ? _c("csp-form-group-input", {
              attrs: {
                form: _vm.insurancePolicyForm,
                property: "comprehensiveCopayment",
              },
            })
          : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }